/* eslint-disable */
const PRIVATIZATION = {
  CUSTOMIZED_LOGOUT_URL: CUSTOMIZED_LOGOUT_PATH || '',
  IS_PRIVATIZATION: CUSTOMIZED_BUILD_TARGET === 'privatization',
  CUSTOMIZED_PATH: CUSTOMIZED_PATH || ''
};

export default PRIVATIZATION;
